var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'Workplace'}}},[_c('img',{staticClass:"cutom",attrs:{"src":_vm.curOrgSetting.menu_logo_url,"alt":"logo"}}),_vm._v(" "),(_vm.showTitle)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9980e8ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Logo.vue
// module id = zMmg
// module chunks = 22